import moment from 'moment-timezone'

import {
  DateFormatOptionsMap,
  MomentLanguageMap,
} from './constants/localization/moment'
import i18n from './locales/i18n'

export const updateMomentUiLocale = (lng: any) =>
  moment.updateLocale(
    MomentLanguageMap[lng],
    DateFormatOptionsMap[lng] as { [x: string]: any },
  )

updateMomentUiLocale(i18n.language)

export default moment
